export default __webpack_public_path__ + "static/media/metamask.50dc2fdb.svg";